import { useMemo, useState } from 'react'
import EstoqueHttp from '../../../../services/api/https/estoque/Estoque.http'
import { errorHandler } from '../../../../services/util/error.service'
import { getPeriodoMesAtual, parseToMysqlFormat } from '../../../../services/util/date.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  GET_INFORMACOES: 'Carregando informações',
  POSICOES: 'Adquirindo posições',
}

const INITIAL_STATE = {
  periodo: getPeriodoMesAtual(),
  selectedPosicao: null,
  selectedEstoque: null,
  posicoes: [],
  estoques: [],
  globalFilter: '',
  loadingMessage: LOAD_MESSAGE.NONE,
  rows: [],
  errorMessage: null,
}

export default function useMovimentacaoPorTipoOperacao() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      getMovimentacaoPorPosição(selectedTp, selectedPosicao, pInicial, pFinal) {
        if (!selectedPosicao)
          setState(prevState => ({ ...prevState, errorMessage: 'Selecione uma posição' }))
        else if (!selectedTp)
          setState(prevState => ({ ...prevState, errorMessage: 'Selecione um TP' }))
        else {
          setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.GET_INFORMACOES }))
          EstoqueHttp.getMovimentacaoPorPosicao(
            selectedTp,
            selectedPosicao.id,
            parseToMysqlFormat(pInicial),
            parseToMysqlFormat(pFinal),
          )
            .then(res =>
              setState(prevState => ({
                ...prevState,
                rows: res,
                loadingMessage: LOAD_MESSAGE.NONE,
              })),
            )
            .catch(err =>
              setState(prevState => ({
                ...prevState,
                loadingMessage: LOAD_MESSAGE.NONE,
                errorMessage: errorHandler(err),
              })),
            )
        }
      },

      getPosicoesEstoque(selectedTp, estoqueId) {
        EstoqueHttp.getPosicoesEstoques(selectedTp, estoqueId)
          .then(res =>
            setState(prevState => ({
              ...prevState,
              posicoes: res,
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      //Actions

      onChange(name, value) {
        setState(prevState => {
          prevState[name] = value
          switch (name) {
            case 'selectedEstoque':
              prevState.loadingMessage = LOAD_MESSAGE.POSICOES
              break
            default:
              break
          }
          return { ...prevState }
        })
      },

      onInit(selectedTp) {
        if (!selectedTp) {
          setState(prevState => ({ ...prevState, errorMessage: 'Selecione um TP' }))
        } else {
          EstoqueHttp.getEstoques(selectedTp)
            .then(res =>
              setState(prevState => ({
                ...prevState,
                estoques: res,
                loadingMessage: LOAD_MESSAGE.NONE,
              })),
            )
            .catch(err =>
              setState(prevState => ({
                ...prevState,
                loadingMessage: LOAD_MESSAGE.NONE,
                errorMessage: errorHandler(err),
              })),
            )
        }
      },

      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },
    }
  }, [])

  return { state, localDispatch }
}
